export const SHOW_SHIPPING_ADDRESS_WARNING_MODAL =
    'SHOW_SHIPPING_ADDRESS_WARNING_MODAL'
